import React, { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DealCard from "@/components/DealCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";

export default function SmartFeed() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("ai");
  const [loading, setLoading] = useState(true);

  const load = async (t) => {
    setLoading(true);
    try {
      let data = [];
      if (t === "ai") {
        const r = await api.get("/catalog/feed?limit=24");
        data = r.data;
      } else if (t === "high") {
        const r = await api.get("/catalog/offers?sort=cashback&limit=24");
        data = r.data;
      } else if (t === "expiring") {
        const r = await api.get("/catalog/offers?sort=expiring&limit=24");
        data = r.data;
      } else if (t === "featured") {
        const r = await api.get("/catalog/offers?featured=true&limit=24");
        data = r.data;
      }
      setItems(data);
    } catch (e) {
      toast.error("Couldn't load feed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(tab);
  }, [tab]);

  const handleShop = async (offer) => {
    try {
      await api.post("/wallet/click", { offer_id: offer.id });
      await api.post("/wallet/simulate-purchase", { offer_id: offer.id, order_amount: 100 });
      toast.success(`Cashback approved: ${fmtMoney((100 * (offer.cashback_rate || 5)) / 200)}`);
    } catch (e) {
      toast.error("Couldn't track shop click");
    }
  };

  const handleSave = async (offer) => {
    try {
      const { data } = await api.post(`/catalog/save/${offer.id}`);
      toast.success(data.saved ? "Deal saved" : "Removed from saved");
    } catch (e) {
      toast.error("Couldn't save");
    }
  };

  return (
    <div data-testid="page-feed">
      <PageHeader eyebrow="Smart Feed" title="My Smart Savings Feed" subtitle="AI-prioritized offers across your favorite categories." />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="ai" data-testid="tab-ai">AI picks</TabsTrigger>
          <TabsTrigger value="high" data-testid="tab-high">Highest cashback</TabsTrigger>
          <TabsTrigger value="featured" data-testid="tab-featured">Featured</TabsTrigger>
          <TabsTrigger value="expiring" data-testid="tab-expiring">Expiring</TabsTrigger>
        </TabsList>
        <TabsContent value={tab}>
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="h-48 rounded-2xl bg-gray-100 animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {items.map((o) => (
                <DealCard key={o.id} offer={o} onShop={handleShop} onSave={handleSave} />
              ))}
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
